// extracted by mini-css-extract-plugin
export default {"external":"a3OtL","header":"b3OtL","layout":"c3OtL","layoutContent":"d3OtL","video":"e3OtL","videoContainer":"f3OtL"};